import { ChangeEvent, MouseEvent } from 'react';
import { Search } from '../assets';

interface filterHeaderProps {
  searchTerm: string;
  onSearch: (event: any) => void;
  className?: string;
  placeholder?: string;
}

const FilterHeader = ({
  searchTerm,
  onSearch,
  className,
  placeholder = 'Search...',
}: filterHeaderProps) => {
  const handleInputClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const handleSearchIconClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <section
      className={`flex flex-row justify-between items-center w-full bg-silver py-3 ${className}`}
    >
      <div>
        <section className="w-full flex justify-end items-center relative">
          <input
            placeholder={placeholder}
            className="w-[440px] rounded border-[#CCCCCC] text-primary-100"
            value={searchTerm}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onSearch(e)}
            onClick={handleInputClick}
          />
          <div
            className="bg-white absolute top-1/2 transform -translate-y-1/2 right-3"
            onClick={handleSearchIconClick}
          >
            <Search />
          </div>
        </section>
      </div>
    </section>
  );
};

export default FilterHeader;
